var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _vm._m(0),
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "租赁类型", prop: "plateType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "730px" },
                      attrs: {
                        disabled: _vm.isGeneratingBills,
                        filterable: "",
                        placeholder: "请选择租赁类型"
                      },
                      model: {
                        value: _vm.childData.leaseType,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "leaseType", $$v)
                        },
                        expression: "childData.leaseType"
                      }
                    },
                    _vm._l(_vm.rentTypeOption, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "小区名称", prop: "areaGroupId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择小区名称"
                      },
                      on: { change: _vm.handleAreaChange },
                      model: {
                        value: _vm.childData.areaGroupId,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "areaGroupId", $$v)
                        },
                        expression: "childData.areaGroupId"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.dicValue,
                        attrs: { label: item.dicName, value: item.dicValue }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "租户", prop: "customerId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px" },
                      attrs: {
                        disabled: !_vm.childData.areaGroupId,
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择租户"
                      },
                      model: {
                        value: _vm.childData.customerId,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "customerId", $$v)
                        },
                        expression: "childData.customerId"
                      }
                    },
                    _vm._l(_vm.tenantOption, function(item) {
                      return _c("el-option", {
                        key: item.customerId,
                        attrs: {
                          label: item.customerName,
                          value: item.customerId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "合同编号", prop: "contractNo" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    model: {
                      value: _vm.childData.contractNo,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "contractNo", $$v)
                      },
                      expression: "childData.contractNo"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "合同名称", prop: "contractName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    model: {
                      value: _vm.childData.contractName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "contractName", $$v)
                      },
                      expression: "childData.contractName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "合同起始日期", prop: "beginDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd"
                    },
                    on: { change: _vm.handleBeginDate },
                    model: {
                      value: _vm.childData.beginDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "beginDate", $$v)
                      },
                      expression: "childData.beginDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "合同结束日期", prop: "endDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd"
                    },
                    on: { change: _vm.handleEndDate },
                    model: {
                      value: _vm.childData.endDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "endDate", $$v)
                      },
                      expression: "childData.endDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.remark") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "730px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 2 }
                    },
                    model: {
                      value: _vm.childData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "remark", $$v)
                      },
                      expression: "childData.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.childData.leaseType === 1
        ? _c(
            "div",
            {
              staticClass: "panel-title",
              staticStyle: { "margin-bottom": "10px" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "16px",
                    "margin-right": "10px",
                    "font-weight": "bold"
                  }
                },
                [_vm._v("租赁房产信息")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    plain: "",
                    icon: "el-icon-plus"
                  },
                  on: { click: _vm.handleSelectRoom }
                },
                [_vm._v("添加房间")]
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "panel-title",
              staticStyle: { "margin-bottom": "10px" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "16px",
                    "margin-right": "10px",
                    "font-weight": "bold"
                  }
                },
                [_vm._v("租赁车位信息")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    plain: "",
                    icon: "el-icon-plus"
                  },
                  on: { click: _vm.handleAddParkingLot }
                },
                [_vm._v("添加车位")]
              )
            ],
            1
          ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.childData.leaseType === 1,
              expression: "childData.leaseType === 1"
            }
          ],
          staticStyle: {
            width: "100%",
            "margin-bottom": "10px",
            "max-height": "262px",
            overflow: "auto"
          },
          attrs: {
            data: _vm.houseList,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "楼栋" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.upName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "房间代码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.resourceCode))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "业主" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.customerName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "房间面积(m²)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.resourceArea))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding fixed-width"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          plain: "",
                          icon: "el-icon-delete"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleHouseDelete(scope.$index)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.childData.leaseType === 2,
              expression: "childData.leaseType === 2"
            }
          ],
          key: _vm.itemKey,
          ref: "chewei",
          staticStyle: {
            width: "100%",
            "margin-bottom": "10px",
            "max-height": "262px",
            overflow: "auto"
          },
          attrs: {
            data: _vm.parkingLotlist,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c(
            "el-table-column",
            {
              attrs: { align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择停车场"
                          },
                          on: {
                            change: function(value) {
                              return _vm.handleGarageChange(value, scope.$index)
                            }
                          },
                          model: {
                            value: scope.row.garageId,
                            callback: function($$v) {
                              _vm.$set(scope.row, "garageId", $$v)
                            },
                            expression: "scope.row.garageId"
                          }
                        },
                        _vm._l(_vm.garageOption, function(item) {
                          return _c("el-option", {
                            key: item.garageId,
                            attrs: {
                              label: item.garageName,
                              value: item.garageId
                            }
                          })
                        }),
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { slot: "header" }, [
                _vm._v(" 停车场"),
                _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
              ])
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: { align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择车位"
                          },
                          on: {
                            change: function(value) {
                              return _vm.handleParkingLotChange(
                                value,
                                scope.$index
                              )
                            }
                          },
                          model: {
                            value: scope.row.resourceId,
                            callback: function($$v) {
                              _vm.$set(scope.row, "resourceId", $$v)
                            },
                            expression: "scope.row.resourceId"
                          }
                        },
                        _vm._l(scope.row.parkingLotOption, function(item) {
                          return _c("el-option", {
                            key: item.parkingLotId,
                            attrs: {
                              label: item.parkingCode,
                              value: item.parkingLotId
                            }
                          })
                        }),
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { slot: "header" }, [
                _vm._v(" 车位号"),
                _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
              ])
            ],
            2
          ),
          _c("el-table-column", {
            attrs: { align: "center", label: "车位业主" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.customerName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "车位面积(m²)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.resourceArea))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding fixed-width"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-delete"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleParkingLotDelete(scope.$index)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c("span", { staticStyle: { "line-height": "32px" } }, [
            _vm._v("附件：")
          ]),
          _c(
            "el-upload",
            {
              ref: "upload",
              attrs: {
                action: _vm.uploadUrl,
                "file-list": _vm.files,
                name: "files",
                "on-error": _vm.handleError,
                "before-upload": _vm.beforeUpload,
                "on-remove": _vm.handleRemove,
                "on-success": _vm.handleSuccess,
                "show-file-list": true,
                "on-preview": _vm.handlePreview
              }
            },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("点击上传")
              ]),
              _c("br")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, title: "预览", width: "600px" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加房间",
            visible: _vm.dialogFormVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("select-house", {
            attrs: {
              "area-group-id": _vm.childData.areaGroupId,
              "checked-nodes": _vm.checkedTreesNodes,
              "show-dialog": _vm.dialogFormVisible
            },
            on: {
              handCancle: _vm.handSelectCancle,
              sendHouseData: _vm.receiveHouseData
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleNext } },
            [_vm._v("下一步")]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新建租户",
            visible: _vm.dialogTenantVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTenantVisible = $event
            }
          }
        },
        [
          _c("add-tenant", {
            attrs: {
              "key-value": _vm.childData.areaGroupId,
              "show-dialog": _vm.dialogTenantVisible
            },
            on: { handTenantCancle: _vm.handTenantCancle }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "panel-title", staticStyle: { "margin-bottom": "10px" } },
      [
        _c(
          "span",
          { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
          [_vm._v("合同基本信息")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }